.library,
.detail {
  display: grid;
  gap: var(--space-3);
  width: 100%;
  min-width: 0;
  color: var(--color-text-primary);
}

.header,
.headerActions,
.toolbar,
.filterButtons,
.detailHeader,
.detailActions,
.detailBadges,
.detailMeta,
.fenceActions,
.panelHeader,
.editorActions,
.outputActions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.header,
.detailHeader {
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.header h1,
.header p,
.detailHeader h1,
.detailHeader p,
.inlineState h2,
.authorityFence h2,
.conflictFence h2,
.officePanel h2,
.panelHeader h2,
.inspectorSection h2 {
  margin: 0;
}

.header h1,
.detailHeader h1 {
  font-size: clamp(1.75rem, 3vw, 2.4rem);
  line-height: 1.08;
  letter-spacing: -0.04em;
}
.eyebrow {
  margin: 0 0 var(--space-1);
  color: var(--color-text-secondary);
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.subtitle,
.secondaryText,
.detailMeta,
.libraryMeta,
.previewLabel,
.dirtyState {
  color: var(--color-text-secondary);
}
.subtitle { margin: 0; }
.headerActions,
.detailActions { flex-wrap: wrap; justify-content: flex-end; }
.authorityNote,
.detailBadges > span,
.capability,
.dirtyState {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 0.8rem;
}
.authorityNote { color: var(--color-text-secondary); }

.primaryButton,
.detailActions button,
.editorActions button,
.fenceActions button,
.outputActions button,
.inlineState button {
  min-height: 44px;
  padding: 0 var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  cursor: pointer;
  font: inherit;
}
.primaryButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  border-color: var(--color-accent);
  background: var(--color-accent);
  color: #fff;
  font-weight: 700;
}
.library button:disabled,
.detail button:disabled { cursor: not-allowed; opacity: 0.55; }
.library button:focus-visible,
.detail button:focus-visible,
.library input:focus-visible,
.detail input:focus-visible,
.detail textarea:focus-visible,
.detail select:focus-visible {
  outline-color: var(--focus-outline-color);
  box-shadow: var(--focus-keyline);
}

.toolbar {
  align-items: end;
  flex-wrap: wrap;
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-recessed);
}
.searchField,
.sortField {
  display: grid;
  flex: 1 1 250px;
  gap: var(--space-1);
}
.searchField > label,
.sortField > span,
.filterGroup legend,
.editorField > span {
  color: var(--color-text-secondary);
  font-size: 0.75rem;
}
.searchControl {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 44px;
  padding: 0 4px 0 var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
}
.searchControl input {
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--color-text-primary);
  font: inherit;
}

.searchControl .primaryButton {
  flex: 0 0 auto;
  min-height: 36px;
  padding-inline: 12px;
}
.filterGroup {
  display: grid;
  flex: 1 1 360px;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
.filterGroup legend { margin-bottom: var(--space-1); }
.filterButtons { flex-wrap: wrap; }
.filterButton {
  min-height: 40px;
  padding: 0 var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-secondary);
  cursor: pointer;
  font: inherit;
}
.filterButton[data-selected="true"] {
  border-color: var(--color-action-inverse);
  background: var(--color-action-inverse);
  color: var(--color-action-inverse-text);
}
.sortField { flex: 0 1 190px; }
.sortField select {
  min-height: 44px;
  padding: 0 var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  font: inherit;
}

.dropZone {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2);
  border: 1px dashed var(--color-boundary);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
  color: var(--color-text-secondary);
}
.uploadQueuePanel,
.skeletonList {
  display: grid;
  gap: var(--space-2);
}
.uploadQueuePanel {
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-recessed);
}
.uploadQueuePanel h2 {
  font-size: 1rem;
}
.uploadQueue {
  display: grid;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}
.uploadQueueItem {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: var(--space-2);
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-surface);
}
.uploadQueueMain {
  display: grid;
  min-width: 0;
  gap: 4px;
}
.uploadQueueName,
.uploadQueueStatus,
.uploadQueueProgress {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  min-width: 0;
}
.uploadQueueName strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.uploadQueueName > span,
.uploadQueueStatus,
.uploadQueueResult,
.uploadQueueError {
  color: var(--color-text-secondary);
  font-size: 0.8rem;
}
.uploadQueueName > span {
  flex: 0 0 auto;
}
.uploadQueueStatus .status {
  margin-left: var(--space-1);
}
.uploadQueueProgress progress {
  width: min(360px, 100%);
  accent-color: var(--color-text-primary);
}
.uploadQueueProgress > span {
  min-width: 3ch;
  color: var(--color-text-secondary);
  font-size: 0.78rem;
}
.uploadQueueResult,
.uploadQueueError {
  margin: 0;
}
.uploadQueueError {
  color: var(--color-text-primary);
}
.uploadQueueActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-1);
  flex-wrap: wrap;
}
.queueAction,
.queueIconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  min-height: 40px;
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  cursor: pointer;
  font: inherit;
}
.queueAction {
  padding-inline: var(--space-1);
  font-size: 0.8rem;
}
.queueIconButton {
  width: 40px;
  padding: 0;
}
.queueAction:disabled,
.queueIconButton:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.skeletonRow {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: var(--space-2);
  min-height: 72px;
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: linear-gradient(90deg, var(--color-surface), var(--color-recessed), var(--color-surface));
  background-size: 200% 100%;
  animation: documents-skeleton 1.5s ease-in-out infinite;
}
.skeletonRow span {
  display: block;
  align-self: center;
  height: 0.75rem;
  border-radius: 999px;
  background: var(--color-hairline);
}
@keyframes documents-skeleton {
  from { background-position: 100% 0; }
  to { background-position: -100% 0; }
}
.fileInput { display: none; }
.textButton {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-text-primary);
  cursor: pointer;
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 0.18em;
}
.progress { width: 120px; accent-color: var(--color-text-primary); }
.progressLabel,
.uploadMessage { font-size: 0.8rem; }
.uploadMessage { color: var(--color-text-primary); }

.libraryMeta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 24px;
  font-size: 0.85rem;
}
.tableWrap {
  overflow: auto;
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
}
.table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  text-align: left;
}
.table th,
.table td {
  padding: var(--space-2);
  border-bottom: 1px solid var(--color-hairline);
  vertical-align: middle;
}
.table thead th {
  color: var(--color-text-secondary);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.table tbody tr:last-child th,
.table tbody tr:last-child td { border-bottom: 0; }
.documentRow:hover { background: var(--color-recessed); }
.documentName {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 280px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-text-primary);
  cursor: pointer;
  font: inherit;
  text-align: left;
}
.documentName > span {
  display: grid;
  gap: 2px;
  min-width: 0;
  flex: 1;
}
.documentName strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.documentName small,
.versionList small {
  color: var(--color-text-secondary);
  font-size: 0.78rem;
  font-weight: 400;
}
.status {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  white-space: nowrap;
}
.status[data-state="ready"] { color: var(--color-text-primary); }
.status[data-state="rejected_unsafe"],
.status[data-state="failed_transient"] { color: var(--color-text-secondary); }
.capability { color: var(--color-text-secondary); }
.rowActions { width: 48px; text-align: right; }
.iconButton {
  display: inline-grid;
  place-items: center;
  width: 40px;
  min-height: 40px;
  padding: 0;
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  cursor: pointer;
}
.officeEditor {
  display: grid;
  gap: var(--space-2);
  min-width: 0;
  min-height: 680px;
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
}
.officeEditorHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-2);
  flex-wrap: wrap;
}
.officeEditorHeader h2 { margin: 0; font-size: 1.1rem; }
.officeEditorHost {
  min-height: 560px;
  overflow: hidden;
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-recessed);
}
.officeEditorError {
  margin: 0;
  padding: var(--space-2);
  border-left: 2px solid var(--color-text-primary);
  color: var(--color-text-secondary);
}
.statusBadge {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 var(--space-1);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  color: var(--color-text-secondary);
  font-size: 0.8rem;
}
.statusBadge[data-state="ready"] {
  border-color: var(--color-text-primary);
  color: var(--color-text-primary);
}
.inlineState,
.officePanel {
  display: grid;
  justify-items: start;
  gap: var(--space-2);
  padding: var(--space-5);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
}
.inlineState p,
.officePanel p { margin: 0; color: var(--color-text-secondary); }
.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.detailHeader { align-items: center; }
.backButton {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  min-height: 44px;
  padding: 0 var(--space-1);
  border: 0;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  font: inherit;
}
.detailHeading { flex: 1 1 320px; min-width: 0; }
.detailBadges { flex-wrap: wrap; margin-top: var(--space-1); color: var(--color-text-secondary); }
.detailBadges > span + span::before { content: "·"; margin-right: var(--space-2); color: var(--color-text-tertiary); }
.detailMeta {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  padding-block: var(--space-2);
  border-block: 1px solid var(--color-hairline);
  font-size: 0.85rem;
}
.authorityFence,
.conflictFence {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-3);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-surface);
  background: var(--color-recessed);
}
.authorityFence p,
.conflictFence p { margin: var(--space-1) 0 0; color: var(--color-text-secondary); }
.conflictFence { border-color: var(--color-text-primary); }
.fenceActions { margin-top: var(--space-2); flex-wrap: wrap; }
.notice {
  margin: 0;
  padding: var(--space-2);
  border-left: 2px solid var(--color-text-primary);
  color: var(--color-text-secondary);
}
.comparePanel {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-3);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-surface);
  background: var(--color-recessed);
}
.comparePanel > p { margin: 0; }
.compareColumns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-2);
}
.comparePane {
  min-width: 0;
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-surface);
}
.comparePane h3 { margin: 0 0 var(--space-1); font-size: 0.85rem; }
.comparePane pre {
  max-height: 360px;
  margin: 0;
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  color: var(--color-text-secondary);
  font: 0.82rem/1.5 var(--font-mono);
}
.detailGrid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);
  gap: var(--space-3);
  align-items: start;
}
.editorPanel,
.inspectorSection {
  min-width: 0;
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
}
.markdownEditor { display: grid; gap: var(--space-3); padding: var(--space-3); }
.panelHeader { justify-content: space-between; align-items: flex-start; }
.panelHeader h2 { font-size: 1.1rem; }
.editorColumns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--space-2);
}
.editorField,
.preview { display: grid; gap: var(--space-1); min-width: 0; }
.viewerPanel,
.imageViewer,
.pdfViewer {
  min-width: 0;
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-recessed);
}
.viewerPanel {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-3);
}
.viewerPanel h2,
.viewerPanel p {
  margin: 0;
}
.viewerPanel p { color: var(--color-text-secondary); }
.textViewer {
  max-height: 620px;
  margin: 0;
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  color: var(--color-text-primary);
  font: 0.88rem/1.55 var(--font-mono);
}
.imageViewer {
  display: grid;
  gap: var(--space-1);
  margin: 0;
  padding: var(--space-2);
}
.imageViewer img {
  display: block;
  max-width: 100%;
  max-height: 680px;
  margin: auto;
  object-fit: contain;
}
.imageViewer figcaption {
  color: var(--color-text-secondary);
  font-size: 0.8rem;
}
.pdfViewer {
  width: 100%;
  min-height: 680px;
}
.editorField textarea {
  width: 100%;
  min-height: 420px;
  box-sizing: border-box;
  padding: var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-recessed);
  color: var(--color-text-primary);
  font: 0.9rem/1.55 var(--font-mono);
  resize: vertical;
}
.preview {
  min-height: 420px;
  padding: var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-recessed);
}
.previewLabel { margin: 0; font-size: 0.75rem; }
.markdownPreview { overflow: auto; color: var(--color-text-primary); line-height: 1.55; }
.markdownPreview p { margin: 0 0 var(--space-1); white-space: pre-wrap; }
.markdownPreview h1,
.markdownPreview h2,
.markdownPreview h3,
.markdownPreview h4,
.markdownPreview p,
.markdownPreview ul,
.markdownPreview ol,
.markdownPreview pre,
.markdownPreview blockquote { margin: 0 0 var(--space-1); }
.markdownPreview h1,
.markdownPreview h2,
.markdownPreview h3,
.markdownPreview h4 { line-height: 1.25; }
.markdownPreview h1 { font-size: 1.35rem; }
.markdownPreview h2 { font-size: 1.15rem; }
.markdownPreview h3 { font-size: 1rem; }
.markdownPreview ul,
.markdownPreview ol { padding-left: 1.4rem; }
.markdownPreview code { font-family: var(--font-mono); font-size: 0.88em; }
.markdownPreview pre {
  overflow: auto;
  padding: var(--space-1);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-surface);
}
.redactionList { display: grid; gap: var(--space-1); margin: 0; padding: 0; list-style: none; }
.redactionList li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-1);
  padding-block: var(--space-1);
  border-bottom: 1px solid var(--color-hairline);
}
.redactionList li:last-child { border-bottom: 0; }
.redactionList li > div { display: grid; gap: 2px; min-width: 0; }
.redactionList small { color: var(--color-text-secondary); font-size: 0.78rem; }
.markdownPreview pre code { white-space: pre; }
.markdownPreview blockquote {
  padding-left: var(--space-2);
  border-left: 2px solid var(--color-boundary);
  color: var(--color-text-secondary);
}
.markdownPreview a { color: inherit; text-underline-offset: 0.18em; }
.markdownPreview p { white-space: pre-wrap; }
.editorActions { justify-content: flex-end; flex-wrap: wrap; }
.inspector {
  display: grid;
  gap: var(--space-1);
}

.inspectorStack {
  display: grid;
  gap: var(--space-1);
}

.inspectorSection {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-2);
}

.inspectorSection h2 {
  font-size: 0.9rem;
}

.inspectorSection > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-1);
  min-height: var(--target-min);
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 750;
}

.inspectorSection > summary span {
  display: grid;
  place-items: center;
  min-width: 24px;
  height: 24px;
  padding-inline: 6px;
  border-radius: 999px;
  background: var(--color-recessed);
  color: var(--color-text-secondary);
  font-size: 0.75rem;
}

details.inspectorSection {
  padding-block: 0;
}

details.inspectorSection[open] {
  padding-block-end: var(--space-2);
}
.metadataList { display: grid; gap: var(--space-1); margin: 0; }
.metadataList > div { display: flex; justify-content: space-between; gap: var(--space-2); }
.metadataList dt { color: var(--color-text-secondary); }
.metadataList dd { margin: 0; text-align: right; }
.versionList { display: grid; gap: var(--space-1); margin: 0; padding: 0; list-style: none; }
.versionList li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-1);
  padding-block: var(--space-1);
  border-bottom: 1px solid var(--color-hairline);
}
.versionList li:last-child { border-bottom: 0; }
.versionList li > span { display: grid; gap: 2px; }
.gitState { display: flex; align-items: center; gap: var(--space-1); margin: 0; }
.warningText { margin: 0; color: var(--color-text-secondary); font-size: 0.85rem; }
.output { display: grid; gap: var(--space-1); padding-top: var(--space-1); border-top: 1px solid var(--color-hairline); }
.output > span { color: var(--color-text-secondary); font-size: 0.85rem; }
.outputActions { flex-wrap: wrap; }
.outputActions button { min-height: 38px; font-size: 0.85rem; }
.detailLoading { display: flex; align-items: center; gap: var(--space-2); padding: var(--space-5); color: var(--color-text-secondary); }
.spinner { animation: documents-spin 0.9s linear infinite; }
@keyframes documents-spin { to { transform: rotate(360deg); } }

@media (max-width: 900px) {
  .detailGrid,
  .editorColumns { grid-template-columns: 1fr; }
  .inspector { order: 2; }
  .editorField textarea,
  .preview { min-height: 300px; }
}
@media (max-width: 640px) {
  .headerActions,
  .detailActions {
    width: 100%;
    justify-content: flex-start;
  }

  .headerActions > button,
  .detailActions > button {
    flex: 1 1 160px;
  }

  .dropZone {
    grid-template-columns: auto 1fr;
  }

  .dropZone:not([data-active="true"]) {
    display: none;
  }

  .filterButtons {
    flex-wrap: nowrap;
    margin-inline: -10px;
    padding-inline: 10px;
    overflow-x: auto;
    scroll-snap-type: x proximity;
  }

  .filterButton {
    flex: 0 0 auto;
    scroll-snap-align: start;
  }

  .dropZone .textButton,
  .dropZone .progress,
  .dropZone .progressLabel,
  .dropZone .uploadMessage {
    grid-column: 2;
  }

  .tableWrap {
    overflow: visible;
    border: 0;
    background: transparent;
  }

  .table {
    display: block;
    min-width: 0;
  }

  .table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }

  .table tbody {
    display: grid;
    gap: var(--space-1);
  }

  .documentRow {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    padding: var(--space-1);
    border: 1px solid var(--color-hairline);
    border-radius: var(--radius-control);
    background: var(--color-surface);
    box-shadow: var(--shadow-surface);
  }

  .table th,
  .table td {
    display: block;
    padding: 4px;
    border: 0;
    text-align: start;
  }
  .table td[data-label] {
    display: grid;
    grid-template-columns: minmax(7rem, 30%) minmax(0, 1fr);
    gap: var(--space-1);
    align-items: center;
  }

  .table td[data-label]::before {
    content: attr(data-label);
    color: var(--color-text-secondary);
    font-size: 0.75rem;
  }

  .documentRow th {
    grid-column: 1 / -1;
  }

  .uploadQueueItem {
    grid-template-columns: 1fr;
  }

  .uploadQueueActions {
    justify-content: flex-start;
  }

  .queueAction,
  .queueIconButton {
    min-height: 44px;
  }

  .documentName {
    width: 100%;
    min-width: 0;
    min-height: var(--target-min);
  }

  .rowActions {
    grid-column: 2;
    grid-row: 2 / span 2;
    align-self: center;
  }
}
